<script setup>
import { Link } from '@inertiajs/vue3'

const props = defineProps({
  rows: {
    type: Array,
    default: [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="search-result-table py-4" data-testid="search-results">
    <DataTable :loading="loading" :value="rows" responsive show-empty hover outlined>
      <template #empty>
        <div class="text-center my-3">{{ $t(`messages.no-results`) }}</div>
      </template>
      <template #loading>
        <div class="m-2 text-center">
          <ProgressSpinner class="align-middle"></ProgressSpinner>
          <strong>{{ $t('messages.loading') }}...</strong>
        </div>
      </template>
      <Column field="name" header="Nimetus"></Column>
      <Column field="type" header="Liik">
        <template #body="slotProps">
          <Tag v-if="slotProps.data.resultType === 'parcel'" severity="secondary" :value="slotProps.data.type" />
          <template v-else>{{ slotProps.data.type }}</template>
        </template>
      </Column>
      <Column field="usage" header="Kasutusotstarve"></Column>
      <Column field="status" header="Seisund"></Column>
      <Column field="address" header="Aadress">
        <template #body="slotProps">
          <div class="flex items-center justify-between">
            <div>
              {{ slotProps.data.address }}
            </div>
            <div v-if="slotProps.data.evaluation">
              <Chip class="py-0 pl-0 pr-4" v-tooltip.top="slotProps.data.evaluation.evaluated_at">
                <span class="bg-primary text-primary-contrast rounded-full w-6 h-6 flex items-center justify-center text-xs">
                  {{ slotProps.data.evaluation.user_name.charAt(0) }}
                </span>
                <span class="font-medium text-gray-500 text-xs">{{ slotProps.data.evaluation.user_name }}</span>
              </Chip>
            </div>
          </div>
        </template>
      </Column>
      <Column field="cadaster" header="Detailandmed">
        <template #body="slotProps">
          <div v-if="slotProps.data.resultType === 'parcel'">
            <Link
              :href="`/detail?cadaster-id=${slotProps.data.cadaster}`"
              class="text-blue-600"
              data-testid="search-detail-link-parcel"
            >
              {{ $t(`messages.searchPage.detail-info`) }} ({{ slotProps.data.cadaster }})
            </Link>
          </div>
          <div
            v-else-if="slotProps.data.type != 'Hoone' || slotProps.data.cadaster?.split(',').length <= 1"
          >
            <Link :href="`/detail?ehr-id=${slotProps.data.ehrCode}`" class="text-blue-600" data-testid="search-detail-link">
              {{ $t(`messages.searchPage.detail-info`) }}
            </Link>
          </div>
          <div v-else v-for="cds in slotProps.data.cadasterDetailed">
            <Link
              :href="`/detail?ehr-id=${slotProps.data.ehrCode}&cadaster-id=${cds.katastritunnus}`"
              class="text-blue-600"
              data-testid="search-detail-link"
            >
              {{ $t(`messages.searchPage.detail-info`) }} ({{ cds.katastritunnus }},
              {{ cds.lahiaadress }})
            </Link>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>
